export const contentTableConfig = {
  title: '关键词回复统计',
  propList: [
    { prop: 'keyword', label: '关键词', minWidth: '80' },
    { prop: 'sum5', label: '五个时间段累计', minWidth: '110', sortable: true },
    { prop: 'sumAll', label: '全天累计', minWidth: '80', sortable: true },
    { prop: 'teacher', label: '老师', minWidth: '80' },
    { prop: 'classname', label: '节目', minWidth: '120' },
    {
      label: '操作',
      minWidth: '120',
      slotName: 'handler'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
